module.exports = __webpack_public_path__ + "static/media/riley.16e9a5ac.jpg";